export default "__VITE_ASSET__BwmEUOXv__"